import { PropsWithChildren } from "react";

interface LabelProps extends PropsWithChildren {
  title?: string;
  required?: boolean;
  contentAlignment?: "left" | "right";
  labelAlignment?: "center" | "start";
  itemsAlignment?: "justify-between";
}

export function Label({
  title,
  required,
  children,
  contentAlignment = "left",
  labelAlignment = "center",
  itemsAlignment,
}: LabelProps) {
  return (
    <div
      className={`flex w-full ${labelAlignment === "center" ? "items-center" : ""} flex-row lg:flex-nowrap gap-2.5 py-2.5 justify ${itemsAlignment}`}
    >
      {contentAlignment === "right" && children}
      <label
        className={`form-label ${labelAlignment === "center" ? "items-center" : ""}  flex  gap-1 max-w-56 text-[#252F4A] !font-normal`}
      >
        {title}
        {required && <span className="text-red-500">*</span>}
      </label>
      {contentAlignment === "left" && children}
    </div>
  );
}
